import { Navigate, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { AuditLogPage } from "@/pages/AuditLogPage";
import { BiPage } from "@/pages/BiPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { LoginPage } from "@/pages/LoginPage";
import { MarketDraftsPage } from "@/pages/MarketDraftsPage";
import { MarketsPage } from "@/pages/MarketsPage";
import { NewsPage } from "@/pages/NewsPage";
import { PaymentConfigsPage } from "@/pages/PaymentConfigsPage";
import { ResolutionsPage } from "@/pages/ResolutionsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { UsersPage } from "@/pages/UsersPage";
import { WithdrawalsPage } from "@/pages/WithdrawalsPage";

/**
 * Mappa di routing del backoffice.
 *
 * Layout:
 *  - /login (pubblica)
 *  - / (e tutte le altre operative) richiede ruolo `operation` o `admin`
 *  - /settings richiede `admin`
 *
 * Le guard sono Outlet-based: i route nested vivono dentro <Layout> così la
 * sidebar/topbar sono renderizzate una sola volta e l'Outlet swap-a solo la
 * pagina.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Tutte le pagine ops (operation + admin) */}
      <Route element={<ProtectedRoute minRole="operation" />}>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/markets" element={<MarketsPage />} />
          <Route path="/market-drafts" element={<MarketDraftsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/resolutions" element={<ResolutionsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/withdrawals" element={<WithdrawalsPage />} />
          <Route path="/audit" element={<AuditLogPage />} />
          <Route path="/bi" element={<BiPage />} />
        </Route>
      </Route>

      {/* Pagine admin-only */}
      <Route element={<ProtectedRoute minRole="admin" />}>
        <Route element={<Layout />}>
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/payment-configs" element={<PaymentConfigsPage />} />
        </Route>
      </Route>

      {/* Catch-all → dashboard se loggato, altrimenti login. La logica è
          delegata al ProtectedRoute che redirige opportunamente. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
